import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";
import enGB from "date-fns/locale/en-GB";
import { menudataSelector } from "reducers/menudata/menudata";
import { useSelector } from "react-redux";
import {
  appdataSelector
} from "reducers/appdata/appdata";
function ScheduleDayPrint(props) {
  const weekdays = [...Array(7).keys()].map(i => enGB.localize.day(i));
  const appdata = useSelector(appdataSelector);
  const menudata = useSelector(menudataSelector);
  const readableDate =
    props.sapDate.substring(6, 8) +
    "/" +
    props.sapDate.substring(4, 6) +
    "/" +
    props.sapDate.substring(0, 4);

  let menu_1 = "";
  let menu_2 = "";
  let menu_3 = "";
  if (props.menus) {
    console.log("weekday - mappedmenus", props.mappedMenus);
    menu_1 = props.mappedMenus[parseInt(props.menus["MENU1_NUMB"])];
    menu_2 = props.mappedMenus[parseInt(props.menus["MENU2_NUMB"])];
    menu_3 = props.mappedMenus[parseInt(props.menus["MENU3_NUMB"])];
  }
  console.log("menu1", menu_1);
  console.log("menu2", menu_2);
  console.log("menu3", menu_3);

  let soups = [];
  let nonSoups = [];
  Object.values(menudata.data.lunchMenuItems).map(value => {
    if (value.DEACTIVATE == "X") {
      // item is disabled, ignore
    } else {
      if (value.SOUP_FLAG == "X") {
        soups.push(value);
      } else {
        nonSoups.push(value);
      }
    }
  });
  return (
    <Card className="pb-2">
      <div className="container-fluid no-breadcrumb chapter FormIntegration pt-2 pb-2">
        <Grid container justify="space-between">
          <Grid item xs={12}>
            <div className="mt-2 mb-2">
              <b>{weekdays[props.id]}</b> ({readableDate})
              {menu_1 && (
                <div className="mt-2">
                  menu 1: {menu_1["MENU_" + appdata.language]}{" "}
                  {menu_1['MENU_ALGEN'] != '' && <b>({menu_1["MENU_ALGEN"]})</b>}
                </div>
              )}
              {menu_2 && (
                <div>
                  menu 2: {menu_2["MENU_" + appdata.language]} 
                  {menu_2['MENU_ALGEN'] != '' && <b>({menu_2["MENU_ALGEN"]})</b>}
                </div>
              )}
              {menu_3 && (
                <div>
                  menu 3: {menu_3["MENU_" + appdata.language]}{" "}
                  {menu_3['MENU_ALGEN'] != '' && <b>({menu_3["MENU_ALGEN"]})</b>}
                </div>
              )}
            </div>
          </Grid>
        </Grid>
      </div>
    </Card>
  );
}

export default ScheduleDayPrint;
